import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import toastr from "toastr";

// Crypto Redux States
import {
  GET_THRESHOLD,
  GET_DYNAMIC_THRESHOLD,
  POST_ALERT_SETUP,
  POST_DISABLE_THRESHOLD_ALERTS,
  POST_ENABLE_THRESHOLD_ALERTS,
  GET_SERVICE_QUOTA_THRESHOLD,
  GET_QUOTA_MASTER_RESOURCES,
  DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS,
  UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG,
  GET_DEPLOYED_SERVICE_QUOTA_ALERTS,
  UPDATE_DEPLOYED_ALERT
} from "./actionTypes";

//Include Both Helper File with needed methods

import {
  getThresholdSuccess,
  getDynamicThresholdSuccess,
  getDynamicThresholdFail,
  getThresholdFail,
  postAlertSetupFail,
  getQuotaThresholdSuccess,
  getQuotaMasterResourcesSuccess,
  getQuotaMasterResources,
  getQuotaMasterResourcesFail,
  getQuotaThresholdFail,
  updateQuotMasterResourceConfigSuccess,
  updateQuotMasterResourceConfigFail,
  deployServiceQuotaAlertsSuccess,
  deployServiceQuotaAlertsFail,
  updateDeployedAlertSuccess, updateDeployedAlertFail
} from "./actions";

import {
  getThreshold,
  postSetupAlertUrl,
  postDisableThresholdAlertUrl,
  postEnableThresholdAlertUrl,
  getServiceQuotaThreshold,
  getQuotaMasterResourcesUrl,
  getServiceQuotaThresholdUrl,
  onDeployMasterResourceAlertsUrl,
  updateMasterResourceAlertsConfigUrl,
  getDeployedServiceQuotaAlertsUrl,
  updateDeployedAlertsUrl
} from "../../helpers/fakebackend_helper";
import {showNotification} from "../../components/Common/notification";

function* onGetThreshold(threshold_type) {
  const response = yield call(getThreshold, threshold_type.payload);
  yield put(getThresholdSuccess(response));

}

function* onGetDynamicThreshold(threshold_type) {
  const response = yield call(getThreshold, threshold_type.payload);
  yield put(getDynamicThresholdSuccess(response));
}


function* onPostAlertSetup({ payload }) {
  const response = yield call(postSetupAlertUrl, payload.alerts);
  payload.history('/cloud-resources')
}

function* onPostDisableThresholdAlerts({ payload: { alerts } }) {
   const response = yield call(postDisableThresholdAlertUrl, alerts);
   
   toastr.success("Alerts disabled successfully");
}

function* onPostEnableThresholdAlerts({ payload: { alerts } }) {
  const response = yield call(postEnableThresholdAlertUrl, alerts);
    
  toastr.success("Alerts enabled successfully");
}

function* onGetServiceQuotaThreshold() {
  try {
    const response = yield call(getServiceQuotaThresholdUrl);
    yield put(getQuotaThresholdSuccess(response));
  } catch (error) {
    yield put(getQuotaThresholdFail(error));
  }
}

function* onGetQuotaMasterResources() {
  try {
    const response = yield call(getQuotaMasterResourcesUrl);
    yield put(getQuotaMasterResourcesSuccess(response));
  }catch (error) {
    yield put(getQuotaMasterResourcesFail(error));
  }
}
function *onDeployQuotaMasterResourceAlerts({payload:data}){ {
  try{
    const response = yield call(onDeployMasterResourceAlertsUrl, data);
  }catch (error) {
    showNotification('error', 'Error', 'Failed to deploy alerts');
  }
  }
}

function* onUpdateMasterResourceAlertsConfig({ payload:data }) {
  try {
    const response = yield call(updateMasterResourceAlertsConfigUrl, data);
    yield put(updateQuotMasterResourceConfigSuccess(response));
  } catch (error) {
    yield put(updateQuotMasterResourceConfigFail(error));
  }
}

function *getAllDeployedServiceAlerts(){
  try{
    const response = yield call(getDeployedServiceQuotaAlertsUrl);
    yield put(deployServiceQuotaAlertsSuccess(response));
  } catch (error){
    yield put(deployServiceQuotaAlertsFail(error))
  }
}

function* updateDeployedAlerts({ payload :data}) {
  try {
    const response = yield call(updateDeployedAlertsUrl, data);
    yield put(updateDeployedAlertSuccess(response));
  } catch (error) {
    yield put(updateDeployedAlertFail(error));
  }
}
function* thresholdSaga() {
  yield takeEvery(GET_THRESHOLD, onGetThreshold);
  yield takeEvery(POST_ALERT_SETUP, onPostAlertSetup);
  yield takeEvery(POST_DISABLE_THRESHOLD_ALERTS, onPostDisableThresholdAlerts);
  yield takeEvery(POST_ENABLE_THRESHOLD_ALERTS, onPostEnableThresholdAlerts);
  yield takeEvery(GET_DYNAMIC_THRESHOLD, onGetDynamicThreshold);
  yield takeEvery(GET_SERVICE_QUOTA_THRESHOLD, onGetServiceQuotaThreshold);
  yield takeEvery(GET_QUOTA_MASTER_RESOURCES, onGetQuotaMasterResources);
  yield takeEvery(DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS, onDeployQuotaMasterResourceAlerts);
  yield takeEvery(UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG, onUpdateMasterResourceAlertsConfig);
  yield takeEvery(GET_DEPLOYED_SERVICE_QUOTA_ALERTS, getAllDeployedServiceAlerts);
  yield takeEvery(UPDATE_DEPLOYED_ALERT, updateDeployedAlerts);
}

export default thresholdSaga;
